import { render, staticRenderFns } from "./mainclosemy.vue?vue&type=template&id=1682a2b6&"
import script from "./mainclosemy.vue?vue&type=script&lang=js&"
export * from "./mainclosemy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports